<template>
  <nav class="navigation">
    <nav-desktop-utility></nav-desktop-utility>
    <el-row type="flex" :align="'middle'" justify="space-between">
      <el-col>
        <router-link :to="homeRoute" class="logo">
          <span class="sr-only sr-only-focusable">{{ $t('menuHome') }}</span>
        </router-link>
      </el-col>
      <el-col>
        <div class="navigation__mobile hidden-md-and-up" v-if="isValidUser">
          <a href @click.prevent="toggleMobileNavigation"
            :class="mobileMenuActive ? 'el-icon-close' : 'el-icon-custom-menu'">
            <span class="sr-only sr-only-focusable">{{ $t('menuMenu') }}</span>
          </a>
        </div>
        <nav-desktop class="hidden-sm-and-down" v-if="isValidUser" :desktopMenuActive="desktopMenuActive"
          @setDesktopMenuActive="setDesktopMenuActive"></nav-desktop>
      </el-col>
    </el-row>
    <nav-mobile :active="mobileMenuActive" :closeNavigation="closeNavigation"></nav-mobile>
  </nav>
</template>

<script>
import authentication from '@/authentication';
import user from '@/components/user';
import NavDesktopUtility from './NavDesktopUtility.vue';
import NavDesktop from './NavDesktop.vue';
import NavMobile from './NavMobile.vue';
import { mapState } from 'vuex';

export default {
  name: 'NavMain',
  props: {
    desktopMenuActive: {
      type: Boolean,
      required: true,
    },
    mobileMenuActive: {
      type: Boolean,
      required: true,
    },
    toggleMobileNavigation: {
      type: Function,
      required: true,
    },
    closeNavigation: {
      type: Function,
      required: true,
    }
  },
  data() {
    return {
    };
  },
  computed: {
    ...mapState(user.store.namespace, [
      'currentUser'
    ]),
    ...mapState(authentication.store.namespace, [
      'isLoggedIn'
    ]),
    isValidUser() {
      return this.isLoggedIn &&
        this.currentUser.approved;
    },
    homeRoute() {
      if (this.isValidUser) {
        return { name: 'Home' };
      } else if (this.isLoggedIn) {
        return { name: 'Settings' };
      } else {
        return { name: 'Login' };
      }
    },
  },
  methods: {
    setDesktopMenuActive(active) {
      this.$emit('setDesktopMenuActive', active);
    }
  },
  components: {
    NavDesktop,
    NavDesktopUtility,
    NavMobile,
  }
}
</script>

<style lang="scss" scoped>
@import '@/assets/base/_variables.scss';
@import 'element-theme-chalk/src/mixins/mixins.scss';

.navigation {
  color: $--color-white;
  background-color: $--color-black;
  padding: 10px 20px 10px 0;

  @include res(md) {
    background-color: $--color-white;
    padding: 0;
  }

  &__mobile {
    text-align: right;

    &>a {
      text-decoration: none;

      &.el-icon-custom-menu {
        color: $--color-white;

        &:visited {
          color: $--color-white;
        }
      }

      &.el-icon-close {
        border-radius: 50%;
        color: $--color-primary;
        background-color: $--color-white;
        font-size: 22px;
        font-weight: bold;
        padding: 5px;

        &:visited {
          color: $--color-primary;
        }
      }
    }
  }

}

// This class is also used to force the logo to be copied 
// into the static folder for branded emails

.logo {
  overflow: hidden;
  display: block;
  box-sizing: border-box;
  background-image: url("@/assets/images/logo.png");
  background-repeat: no-repeat;
  background-position: left;
  background-size: auto $--menu-height-mobile - 20px;
  height: $--menu-height-mobile - 20px;
  width: 200px;

  @include res(md) {
    background-size: auto $--menu-height-desktop-md;
    height: $--menu-height-desktop-md;
    width: 315px;
  }

  @include res(lg) {
    background-size: auto $--menu-height-desktop;
    height: $--menu-height-desktop;
    width: 400px;
  }

}
</style>
